import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const OrganizationUserTitleColumn = (props) => {
    const { organizationUser } = props;

    return (
        <div>
            <Typography
                sx={{
                    fontStyle: 'normal',
                    fontWeight: '400',
                    fontSize: '0.875rem',
                    color: '#333333',
                }}
            >
                {organizationUser?.jobTitle || ''}
            </Typography>
        </div>
    );
};

OrganizationUserTitleColumn.propTypes = {
    organizationUser: PropTypes.object.isRequired,
};

export default OrganizationUserTitleColumn;
